<template>
  <div class="out_wrap">
    <div class="left"></div>
    <div class="container">
      <video src="https://kc-res.izsw.net/apps/qrobot-inspection-system/loginBg.mp4" autoplay loop muted="true"></video>
      <div class="title">
        <img src="https://kc-res.izsw.net/apps/qrobot-inspection-system/loginTitle.png" alt=""
          style="width: 100%; height: 81px" />
      </div>
      <div class="login">
        <div class="login-title">
          <span>用户登录</span>
        </div>
        <el-form class="login-contain" ref="loginForm" :model="loginForm" :rules="rules">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入账号" class="userInfo username">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="loginForm.password" class="userInfo userPwd" />
          </el-form-item>
          <el-button @click="login">登录</el-button>
        </el-form>
      </div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
import { login } from '../assets/api/login';
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户账号!",
            trigger: "blur"
          },
          {
            min: 11,
            max: 11,
            message: "账号长度为11位，请输入正确格式的账号!",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入用户密码!",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "密码长度为6~20位，请输入正确格式的密码！",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    login() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          login({ ...this.loginForm }).then(res => {
            const { code, data, msg } = res
            if (code == 200) {
              localStorage.setItem('login', true);
              localStorage.setItem('token', data.token);
              this.$store.dispatch('setLogin', true);
              this.$store.dispatch('setToken', data.token);
              this.$message({
                type: "success",
                message: "登陆成功，欢迎您使用该系统！",
                onClose: () => {
                  this.$router.push('/InspectionTask');
                }
              })
            } else {
              console.log(123);
              this.$message.error(msg)
            }
          })
        } else {
          this.$message.error("请将信息填写完整！")
        }
      })
    }
  },
  created() {
  },
  mounted() {
    const style = document.createElement("style");
    style.innerHTML = `
      #app {
        background: linear-gradient(to top right, #000000, #000000, #000000, #0a1029);
      }
    `;
    document.head.appendChild(style);
  }
}
</script>

<style lang="scss" scoped>
.out_wrap {
  display: flex;
  background: none;
}

.container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    position: fixed;
  }

  .title {
    position: absolute;
    right: 43px;
    top: 150px;
  }

  .login {
    position: absolute;
    width: 485px;
    height: 437px;
    top: 340px;
    right: 50px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/loginImg1-1.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    .login-title {
      position: absolute;
      left: 190px;
      top: 60px;
      width: 106px;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #c7d7ff;
      line-height: 35px;
    }

    .el-form {
      display: flex;
      flex-direction: column;
      width: 340px;
      position: absolute;
      left: 73px;
      top: 139px;

      .userInfo {
        & /deep/ .el-input__inner {
          background: #334e87;
          border: none;
          border-radius: 21px;
          padding-left: 50px;
          color: #fff;
          font-size: 16px;
        }

        &::before {
          content: "";
          display: inline-block;
          width: 20px;
          height: 22px;
          position: absolute;
          left: 16px;
          top: 9px;
        }
      }

      .username::before {
        background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/loginUserIcon.svg") no-repeat center center / 100%;
      }

      .userPwd::before {
        background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/loginPassIcon.svg") no-repeat center center / 100%;
      }

      .el-form-item {
        margin-bottom: 0;

        .el-input {
          width: 340px;
          height: 42px;
          border-radius: 21px;
          border: none;
          margin-bottom: 40px;
          position: relative;
        }

        /deep/ .el-form-item__error {
          top: 50%;
          left: 16px;
          font-size: 16px;
        }
      }

      .el-button {
        width: 340px;
        height: 42px;
        background: #5880e5;
        border-radius: 21px;
        border: none;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue